// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Ryvq","alert":"SettungsInbox_alert__26umi"};